import React, { Component } from 'react';
import { flowRight as compose, get } from 'lodash';
import Moment from 'react-moment';
import { withRouter } from 'providers';
import { inject, observer } from 'mobx-react';
import { Box, Link, Grid, Button, TextField, CircularProgress, DialogTitle, DialogContent, DialogActions, Dialog } from '@mui/material';
import { ArrowBackIos as ArrowBackIcon } from '@mui/icons-material';

import styles from './styles';
import acl from 'constants/acl';

class TicketMiniDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
      voiding: false,
      showDialog: false,
    };
  }

  closeDialog = () => {
    this.setState({ showDialog: false });
  };

  onVoidTicket = () => {
    const { reason } = this.state;
    const { store, ticket, onBack, reloadData } = this.props;
    const { ticketStore } = store;

    if (!reason) return;

    this.setState({ voiding: true });
    ticketStore.voidTicket(ticket.id, reason).then(() => {
      if (this.props.onUpdate) this.props.onUpdate();
      this.closeDialog();
      onBack(reloadData);
    });
  };

  render() {
    const { reason, voiding, showDialog } = this.state;
    const { ticket, onBack, store } = this.props;
    const { permissionStore } = store;
    const bookingSessionId = get(ticket, 'attributes.session', '');

    const isDeniedVoidTicket = permissionStore.isDenied(acl.TICKETS.VOID);

    return (
      <Box p={2} sx={styles.container}>
        <Box mb={2} align="left">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
              <ArrowBackIcon sx={styles.backItem} color="primary" onClick={() => onBack()} fontSize="small" />
              <Link sx={styles.backItem} onClick={() => onBack()} underline="always" color="primary">
                Back to Pending Route List
              </Link>
            </Grid>
            <Grid>
              {!isDeniedVoidTicket && (
                <Box mx={1} component="span">
                  <Button variant="contained" size="small" disableElevation color="secondary" onClick={() => this.setState({ showDialog: true })}>
                    Void
                  </Button>
                </Box>
              )}
              <Box component="span">
                <Button variant="contained" size="small" target="_blank" disableElevation href={`/ticket-booking/${bookingSessionId}`}>
                  View in booking
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box align="left">
          <Grid container spacing={2} justifyContent="space-between" alignItems="center">
            <Grid>
              <Box sx={styles.label}>Route Ticket - {ticket.name}</Box>
            </Grid>
            <Grid>
              <Box sx={{ ...styles.bold, color: '#fa6725' }}>{ticket.status || 'PENDING'}</Box>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box py={0.5}>
                <span>Boxes: </span>
                <Box component="span" sx={styles.bold}>
                  {ticket.attributes.shipment_count_min} - {ticket.attributes.shipment_count_max}
                </Box>
              </Box>
              <Box py={0.5}>
                <span>Amount: </span>
                <Box component="span" sx={styles.bold}>
                  ${ticket.attributes.tour_cost_min} - ${ticket.attributes.tour_cost_max}
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box py={0.5}>
                <span>Est. Time Window: </span>
                <Box component="span" sx={styles.bold}>
                  <Moment interval={0} format="hh:mm a">
                    {ticket.target_start_ts}
                  </Moment>{' '}
                  -{' '}
                  <Moment interval={0} format="hh:mm a">
                    {ticket.target_end_ts}
                  </Moment>
                </Box>
              </Box>
              <Box py={0.5}>
                <span>Zones: </span>
                <Box component="span" sx={{ ...styles.bold, wordBreak: 'break-all' }}>
                  {ticket.attributes.zones}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Dialog open={showDialog} onClose={this.closeDialog} style={{ zIndex: 100000 }} PaperProps={{ style: { minWidth: 500 } }}>
          <DialogTitle align="center">
            <Box>
              <Box>
                <strong>Void Ticket</strong>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <TextField
              label="Reason"
              multiline
              rows={5}
              variant="outlined"
              fullWidth
              disabled={voiding}
              value={reason}
              onChange={(e) => this.setState({ reason: e.target.value })}
              margin="dense"
            />
          </DialogContent>
          <DialogActions>
            <Box px={2} pb={1}>
              {voiding && (
                <Box px={1} style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                  <CircularProgress color="primary" size={24} />
                </Box>
              )}
              <Button color="secondary" variant="contained" disableElevation onClick={this.closeDialog} style={{ marginRight: 15 }} size="small">
                Cancel
              </Button>
              <Button color="primary" disableElevation variant="contained" disabled={!reason || voiding} onClick={this.onVoidTicket} size="small">
                Void
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default compose(withRouter, inject('store'), observer)(TicketMiniDetail);
